var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { businessService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from '~/core/decorator';
import { Service } from '~/core/service';
var CaseWaringInfoService = /** @class */ (function (_super) {
    __extends(CaseWaringInfoService, _super);
    function CaseWaringInfoService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 个案管理模块中，添加警告信息
     * @param data 查询参数实体
     */
    CaseWaringInfoService.prototype.insertCaseWarningInfo = function (data, loading) {
        return this.netService.send({
            server: businessService.caseWaringInfoController.insertCaseWarningInfo,
            data: data,
            loading: loading
        });
    };
    /**
     * 查询警告列表
     * @param caseId 案件id
     */
    CaseWaringInfoService.prototype.queryCaseWarningInfo = function (caseId, loading) {
        return this.netService.send({
            server: businessService.caseWaringInfoController.queryCaseWarningInfo,
            data: {
                caseId: caseId
            },
            loading: loading
        });
    };
    /**
     * 查询警告信息列表
     */
    CaseWaringInfoService.prototype.queryCaseWarningInfoList = function (caseId, loading) {
        return this.netService.send({
            server: businessService.caseWaringInfoController.queryCaseWarningInfoList,
            data: {
                caseId: caseId
            },
            loading: loading
        });
    };
    /**
     * 修改警告信息
     */
    CaseWaringInfoService.prototype.editCaseWarningInfo = function (model, id, loading) {
        return this.netService.send({
            server: businessService.caseWaringInfoController.editCaseWarningInfo,
            data: {
                msg: model.msg,
                warnInfoId: id
            },
            loading: loading
        });
    };
    /**
     * 删除警告信息
     */
    CaseWaringInfoService.prototype.deleteCaseWarningInfo = function (id, loading) {
        return this.netService.send({
            server: businessService.caseWaringInfoController.deleteCaseWarningInfo,
            data: {
                infoId: id
            },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseWaringInfoService.prototype, "netService", void 0);
    return CaseWaringInfoService;
}(Service));
export { CaseWaringInfoService };
